import { render, staticRenderFns } from "./SecureBijlagen.vue?vue&type=template&id=b60dea08"
import script from "./SecureBijlagen.vue?vue&type=script&lang=js"
export * from "./SecureBijlagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports